/* boutiq.ski — additions of 18 October: get-in-touch dialog. Loaded after arlberg.js. */

/* ==========================================================================
   "Get in touch": the message form opens in a native dialog. After sending,
   the page reloads with the answer inside the dialog, so it opens again.
   ========================================================================== */
(() => {
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cta-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.ctaOpen);
      if (dialog?.showModal) { dialog.showModal(); dialog.querySelector('input:not([type="hidden"])')?.focus(); }
      return;
    }
    const closer = event.target.closest('[data-cta-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    // a click on the backdrop closes it too
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('cta__dialog')) event.target.close();
  });
  document.querySelectorAll('.cta__dialog').forEach((dialog) => {
    if (dialog.querySelector('[data-cta-answered]') && dialog.showModal) dialog.showModal();
  });
})();

/* ==========================================================================
   Icons for every fact. The theme gives a fact an icon only when its text
   names something unmistakable (helicopter, lodge, transfer …). Typical fact
   lines like "Duration: 5 hours", "Price: …", "Group: max 6" or "Season:
   December to April" stayed bare. These rules fill the gaps afterwards, and
   whatever still matches nothing gets a check mark — in the highlights row
   and in "what's included", never in "not included".
   ========================================================================== */
(() => {
  const RULES = [
    [/^\s*(duration|dauer|time|zeit)\b|\b\d+(\.\d+)?\s*(to\s*\d+(\.\d+)?\s*)?(hours?|hrs?|stunden|h)\b|half[-\s]?day|full[-\s]?day/i, 'clock'],
    [/^\s*(price|preis|cost|kosten)\b|€|\beur\b|per person|pro person/i, 'tag'],
    [/^\s*(group|gruppe|guests?|participants?|teilnehmer|people|personen)\b|\bmax(imum)?\b.*\d|\bmin(imum)?\b.*\d|small group/i, 'users'],
    [/^\s*(season|saison|dates?|datum|termine?|when)\b|january|february|march|april|may|june|july|august|september|october|november|december|jänner|januar|februar|märz|winter|summer/i, 'calendar'],
    [/^\s*(languages?|sprachen?)\b|german|english|deutsch|englisch|mandarin|french|italian/i, 'globe'],
    [/^\s*(level|skill|niveau|könnens)|beginner|intermediate|advanced|experienced|off[-\s]?piste/i, 'mountain'],
    [/^\s*(meeting point|treffpunkt|start|location|ort|where)\b/i, 'map-pin'],
    [/\b\d+\s*(days?|tage?|nights?|nächte|weeks?|wochen)\b/i, 'calendar'],
    [/yacht|boat|sail/i, 'sail'],
    [/touring|skin(s|ning)?\b|ascent/i, 'touring'],
    [/snow|powder|tiefschnee/i, 'snow'],
    [/route|itinerary|program/i, 'route'],
    [/instructor|coach|guide/i, 'guide'],
  ];
  const iconFor = (text) => (RULES.find(([re]) => re.test(text)) || [])[1] || null;

  const markup = (scope, name) => {
    const sprite = scope.querySelector('[data-spec-icons]') || document.querySelector('[data-spec-icons]');
    const node = sprite && sprite.querySelector('[data-icon="' + name + '"]');
    return node ? node.innerHTML : '';
  };

  const fill = () => {
    document.querySelectorAll('fact-row .facts__item').forEach((item) => {
      if (item.querySelector('svg')) return;
      const html = markup(item.closest('fact-row') || document, iconFor(item.textContent) || 'check');
      if (html) item.insertAdjacentHTML('afterbegin', html);
    });
    document.querySelectorAll('.speclist:not(.speclist--excluded) .speclist__icon').forEach((slot) => {
      if (slot.querySelector('svg')) return;
      const text = slot.parentElement ? slot.parentElement.textContent : '';
      const html = markup(slot.closest('spec-columns') || document, iconFor(text) || 'check');
      if (html) { slot.innerHTML = html; slot.removeAttribute('aria-hidden'); }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill);
  else fill();
  window.addEventListener('load', fill);
})();
